import EmptyResult from 'shared/components/EmptyResult/EmptyResult';

export default EmptyResult;
